module.exports = __webpack_public_path__ + "static/media/ico-resources.292cd8d4.svg";